import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Card } from "reactstrap";
import InvoiceAside from "./InvoiceAside";
import { useParams, useLocation } from "react-router";
import InvoiceComponent from "./InvoiceComponent";
function ViewInvoiceDetails() {
  let { id }: any = useParams();
  const [sm, setSm] = useState(false);
  const location = useLocation();
  const locationState = location.state as any;
  
  // If we came from InvoicesDrawer or AccountsPayablesDrawer, navigate back to dashboard with drawer state
  const previousPath = locationState?.fromInvoicesDrawer || locationState?.fromAccountsPayablesDrawer
    ? "/dashboard"
    : locationState?.previousPath || "/view-invoice-list";
  
  const previousState = locationState?.previousState;
  const extraFromState = locationState?.extra || {};
  const extra = {
    reduceTableWidth: 130,
    ...extraFromState,
    ...(previousState ? { previousState } : {}),
  };

  return (
    <>
      <Head title="Material Invoice" />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {/* <div
              className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg 
                ${sm ? "content-active" : ""}
              `}
            >
              <InvoiceAside updateSm={setSm} sm={sm} />
            </div> */}
            <InvoiceComponent
              invoiceNumber={id}
              previousPath={previousPath}
              extra={extra}
            />
          </div>
        </Card>
      </Content>
    </>
  );
}

export default ViewInvoiceDetails;
